/*
  KA signup popup (D43). Markup lives in snippets/ka-popup.liquid.

  Flow: 1 answer > 2 scratch card > 3 email > 4 done. The step-1 answer is saved
  to the Klaviyo profile as `ka_interest`. Signups go to Klaviyo's public client
  API (company id and list id are data attributes set from theme settings).

  Triggers (after intent, never a timer): 50% scroll on every device, plus exit
  intent on desktop pointers. Frequency lives in localStorage (always try/catch):
    ka-popup-until   close -> hidden for 14 days
    ka-popup-signed  signup -> never shown again
    ka-popup-closed  closed once -> the teaser tab may reopen it
*/
(function () {
  'use strict';

  var K_UNTIL = 'ka-popup-until';
  var K_SIGNED = 'ka-popup-signed';
  var K_CLOSED = 'ka-popup-closed';
  var REVEAL_AT = 0.6;  // share of the foil cleared before it clears itself
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var NEXT = {
    custom_rifle: ['/pages/build-your-own-rifle', 'Start your build plan'],
    prebuilt_rifle: ['/pages/prebuilt-rifles', 'See prebuilt airsoft rifles'],
    parts: ['/collections/all', 'Shop airsoft parts'],
    tech_work: ['/pages/tech-services', 'See tech services']
  };

  /* ---- pure helpers (also used by the test harness) ---- */
  function pathBlocked(path, list) {
    var p = String(path || '').toLowerCase();
    return String(list || '').split(',').some(function (b) { return b && p.indexOf(b) !== -1; });
  }

  function buildBody(email, interest, listId) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'KA popup: scratch',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { ka_interest: interest },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
  }

  function store(op, key, val) {
    try {
      if (op === 'get') return localStorage.getItem(key);
      if (op === 'set') localStorage.setItem(key, val);
    } catch (e) { /* private mode: cap for this page load only */ }
    return null;
  }

  window.KaPopup = { pathBlocked: pathBlocked, buildBody: buildBody, ready: false };

  function init() {
    var root = document.getElementById('ka-popup');
    if (!root) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (pathBlocked(location.pathname, root.dataset.blocked)) return;

    var tab = document.getElementById('ka-popup-tab');
    var panel = root.querySelector('.ka-popup__panel');
    var steps = root.querySelectorAll('.ka-popup__step');
    var statusEl = root.querySelector('[data-ka-status]');
    var days = parseInt(root.dataset.days, 10) || 14;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var state = { step: 1, interest: '', opener: null, sent: false, revealed: false };
    var signed = store('get', K_SIGNED) === '1';
    var suppressed = Number(store('get', K_UNTIL) || 0) > Date.now();
    var closedBefore = store('get', K_CLOSED) === '1';

    if (signed) return; // never again, no tab

    if (closedBefore && tab) tab.hidden = false;
    if (tab) tab.addEventListener('click', function () { open(tab); });

    /* ---- triggers ---- */
    var armed = !suppressed;
    function otherOverlayOpen() {
      return !!document.querySelector('dialog[open], .menu-drawer[open], #shopify-pc__banner');
    }
    function tryOpen() {
      if (!armed || !root.hidden || otherOverlayOpen()) return;
      open(null);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var h = document.documentElement;
        var max = h.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.5) tryOpen();
      });
    }
    if (armed) {
      window.addEventListener('scroll', onScroll, { passive: true });
      var t0 = Date.now();
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', function (e) {
          // Exit intent: the pointer leaves through the top edge. A short guard
          // stops an instant open on a fast page load; it is not the trigger.
          if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 3000) tryOpen();
        });
      }
    }

    /* ---- open / close ---- */
    function visibleFocusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && !el.closest('[hidden]') && el.offsetParent !== null; }
      );
    }

    function open(opener) {
      if (!root.hidden) return;
      state.opener = opener || document.activeElement;
      armed = false;
      root.hidden = false;
      if (tab) tab.hidden = true;
      document.documentElement.classList.add('ka-popup-open');
      go(state.step, true);
    }

    function close() {
      if (root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('ka-popup-open');
      if (state.sent) {
        store('set', K_SIGNED, '1');
        if (tab) tab.hidden = true;
      } else {
        store('set', K_CLOSED, '1');
        if (tab) tab.hidden = false;
      }
      store('set', K_UNTIL, String(Date.now() + days * 864e5));
      var back = state.opener;
      if (back === document.body || !back || !document.contains(back) || back.hidden) back = state.sent ? null : tab;
      if (back && back.focus) back.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ka-close]')) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = visibleFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (!panel.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });

    /* ---- steps ---- */
    function go(n, noAnim) {
      state.step = n;
      Array.prototype.forEach.call(steps, function (s) {
        var on = Number(s.dataset.step) === n;
        s.hidden = !on;
        s.classList.toggle('is-in', on && !noAnim && !reduced);
      });
      var sec = root.querySelector('[data-step="' + n + '"]');
      var title = sec.querySelector('.ka-popup__title');
      if (n === 2) initScratch();
      // Land on the step title so a screen reader hears the question first.
      title.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-interest]').forEach(function (b) {
      b.addEventListener('click', function () { state.interest = b.dataset.interest; go(2); });
    });
    root.querySelectorAll('[data-ka-back]').forEach(function (b) {
      b.addEventListener('click', function () { go(state.step - 1); });
    });
    root.querySelector('[data-ka-next]').addEventListener('click', function () { go(3); });

    /* ---- scratch card ---- */
    var card = root.querySelector('[data-ka-card]');
    var foil = root.querySelector('[data-ka-foil]');
    var prize = root.querySelector('[data-ka-prize]');
    var revealBtn = root.querySelector('[data-ka-reveal]');
    var nextBtn = root.querySelector('[data-ka-next]');
    var sub = root.querySelector('[data-ka-scratch-sub]');
    var ctx = null, dpr = 1, drawing = false, last = null, lastCheck = 0, w = 0, h = 0;

    function paintFoil() {
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#d9b657'); g.addColorStop(0.25, '#f1dc9b'); g.addColorStop(0.5, '#c79d36');
      g.addColorStop(0.75, '#ead28a'); g.addColorStop(1, '#c79d36');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = 'rgba(125,95,18,.18)';
      ctx.lineWidth = 1;
      for (var x = -h; x < w; x += 10) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
      ctx.fillStyle = '#7d5f12';
      ctx.font = '700 14px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', w / 2, h / 2);
    }

    function initScratch() {
      if (state.revealed || ctx) return;
      var r = card.getBoundingClientRect();
      w = Math.round(r.width); h = Math.round(r.height);
      if (!w || !h) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      foil.width = w * dpr; foil.height = h * dpr;
      ctx = foil.getContext('2d', { willReadFrequently: true });
      ctx.scale(dpr, dpr);
      paintFoil();
      card.dataset.progress = '0';
    }

    function pos(e) {
      var r = foil.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function scratchTo(p) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.strokeStyle = '#000'; // opaque: destination-out erases by source alpha
      ctx.lineWidth = 38; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x + 0.01, p.y); ctx.stroke();
      last = p;
    }
    function cleared() {
      var d = ctx.getImageData(0, 0, foil.width, foil.height).data;
      var n = 0, tot = 0;
      for (var i = 3; i < d.length; i += 16) { tot++; if (d[i] < 128) n++; }
      return n / tot;
    }
    function measure(force) {
      var now = Date.now();
      if (!force && now - lastCheck < 80) return;
      lastCheck = now;
      var p = cleared();
      card.dataset.progress = p.toFixed(2);
      if (p >= REVEAL_AT) reveal();
    }

    foil.addEventListener('pointerdown', function (e) {
      if (!ctx || state.revealed) return;
      drawing = true; last = pos(e);
      try { foil.setPointerCapture(e.pointerId); } catch (x) {}
      scratchTo(last);
      e.preventDefault();
    });
    foil.addEventListener('pointermove', function (e) {
      if (!drawing) return;
      scratchTo(pos(e));
      measure(false);
    });
    function endDraw() { if (drawing) { drawing = false; if (ctx && !state.revealed) measure(true); } }
    foil.addEventListener('pointerup', endDraw);
    foil.addEventListener('pointercancel', endDraw);

    function reveal() {
      if (state.revealed) return;
      state.revealed = true;
      drawing = false;
      if (ctx) ctx.clearRect(0, 0, w, h);
      card.dataset.progress = '1.00';
      card.classList.add('is-revealed');
      prize.removeAttribute('aria-hidden');
      revealBtn.hidden = true;
      nextBtn.hidden = false;
      sub.textContent = 'Revealed: 10% off your first airsoft order.';
      statusEl.textContent = 'Revealed: 10% off your first airsoft order.';
      nextBtn.focus({ preventScroll: true });
    }
    revealBtn.addEventListener('click', reveal);
    prize.setAttribute('aria-hidden', 'true');

    /* ---- email + Klaviyo ---- */
    var form = root.querySelector('[data-ka-form]');
    var input = form.querySelector('input');
    var err = root.querySelector('[data-ka-err]');
    var submit = form.querySelector('[data-ka-submit]');

    function showErr(msg) {
      err.textContent = msg;
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }
    function clearErr() { err.hidden = true; err.textContent = ''; input.removeAttribute('aria-invalid'); }
    function validate() {
      var v = input.value.trim();
      if (!v) { showErr('Enter your email so we know where to send it.'); return false; }
      if (!EMAIL_RE.test(v)) { showErr('That email looks off. Try name@example.com.'); return false; }
      clearErr();
      return true;
    }
    input.addEventListener('blur', function () { if (input.value) validate(); });
    input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) validate(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state.sending || !validate()) { if (!state.sending) input.focus(); return; }
      state.sending = true;
      submit.disabled = true;
      submit.textContent = 'Sending...';
      var body = buildBody(input.value.trim(), state.interest, root.dataset.listId);
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: root.dataset.revision },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        state.sent = true;
        store('set', K_SIGNED, '1');
        finish();
      }).catch(function () {
        showErr('We could not save that just now. Your email is still here. Press the button to try again.');
        submit.textContent = 'Try again';
        input.focus();
      }).then(function () {
        state.sending = false;
        submit.disabled = false;
      });
    });

    function finish() {
      var n = NEXT[state.interest] || NEXT.parts;
      var a = root.querySelector('[data-ka-go]');
      a.setAttribute('href', n[0]);
      a.textContent = n[1];
      go(4);
    }

    window.KaPopup.ready = true;
    window.KaPopup.open = function () { open(document.activeElement); };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
